// eslint-disable-next-line import/no-named-default
import { default as momentTZ } from "moment-timezone";
import MomentUtils from "@date-io/moment";

/**
 * https://github.com/mui-org/material-ui-pickers/issues/329
 */

momentTZ.tz.setDefault("UTC");
export const moment = momentTZ.tz.setDefault("UTC");

class LocalizedUtils extends MomentUtils {
  // eslint-disable-next-line class-methods-use-this
  format(date, formatString) {
    return moment(date)
      .utc()
      .format(formatString);
  }
}

export default LocalizedUtils;
